const highlights = [
  {
    icon: "ri-file-certificate-line",
    title: "Giấy phép hợp lệ",
    desc: "ĐKKD số 0401923171 cấp ngày 10/09/2018 do Sở KH&ĐT TP. Đà Nẵng cấp",
  },
  {
    icon: "ri-building-2-line",
    title: "Địa chỉ văn phòng",
    desc: "Thửa đất số 1235, tờ bản đồ số 06, tổ 16, Phường An Khê, TP. Đà Nẵng",
  },
  {
    icon: "ri-flask-2-line",
    title: "Phòng thí nghiệm",
    desc: "Số 26 đường Phan Anh, Phường Cẩm Lệ, TP. Đà Nẵng",
  },
  {
    icon: "ri-shield-check-line",
    title: "Tiêu chuẩn TCVN",
    desc: "Thực hiện thí nghiệm theo đúng tiêu chuẩn TCVN và 22 TCN hiện hành",
  },
];

export default function AboutSection() {
  return (
    <section id="about" className="py-14 md:py-20 bg-[#F5F7F2]">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        {/* Header */}
        <div className="text-center mb-10 md:mb-14">
          <span className="inline-flex items-center gap-2 text-[#0E5C3A] text-sm font-semibold uppercase tracking-widest mb-3">
            <i className="ri-information-line"></i>
            Về chúng tôi
          </span>
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold text-gray-800 mt-2">
            CÔNG TY TNHH KỸ THUẬT <span className="text-[#0E5C3A]">THUẬN PHÁT</span>
          </h2>
          <div className="w-16 h-1 bg-[#D4A017] mx-auto mt-4 rounded-full"></div>
        </div>

        {/* Main content */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 items-center">
          {/* Left: Image */}
          <div className="relative">
            <div className="rounded-lg overflow-hidden w-full h-[280px] md:h-[380px]">
              <img
                src="https://static.readdy.ai/image/c43dd3b2b6fbcff1b6e6a251cdbd15c0/d0d9263a5ee9bb87566c7cfaa73d7dee.png"
                alt="Đội ngũ kỹ thuật Thuận Phát"
                className="w-full h-full object-cover object-top"
              />
            </div>
            {/* Floating card */}
            <div className="absolute -bottom-5 -right-3 bg-white rounded-lg p-4 w-44">
              <div className="text-2xl font-bold text-[#0E5C3A]">2018</div>
              <div className="text-xs text-gray-500 mt-1">Năm thành lập</div>
              <div className="flex items-center gap-1 mt-1.5">
                {[1,2,3,4,5].map(i => (
                  <i key={i} className="ri-star-fill text-[#D4A017] text-xs"></i>
                ))}
              </div>
              <div className="text-xs text-gray-400 mt-1">Uy tín hàng đầu Đà Nẵng</div>
            </div>
          </div>

          {/* Right: Content */}
          <div>
            <p className="text-gray-600 text-sm md:text-base leading-relaxed mb-4">
              <strong className="text-gray-800">Công ty TNHH Kỹ thuật Thuận Phát</strong> là tổ chức hoạt động 
              thí nghiệm chuyên ngành xây dựng được cấp phép chính thức, chuyên cung cấp các dịch vụ kiểm tra, 
              thử nghiệm vật liệu xây dựng đáp ứng yêu cầu kỹ thuật của các công trình xây dựng dân dụng, 
              công nghiệp và giao thông trên địa bàn TP. Đà Nẵng và các tỉnh miền Trung.
            </p>
            <p className="text-gray-600 text-sm md:text-base leading-relaxed mb-6">
              Với đội ngũ kỹ sư và kỹ thuật viên giàu kinh nghiệm, trang thiết bị hiện đại và quy trình 
              thí nghiệm chuẩn xác, chúng tôi cam kết mang đến kết quả thí nghiệm tin cậy, nhanh chóng, 
              đáp ứng tiến độ thi công của các đơn vị xây dựng.
            </p>

            {/* Giấy phép info */}
            <div className="bg-[#0E5C3A]/5 border border-[#0E5C3A]/20 rounded-lg p-4 mb-6">
              <div className="flex items-start gap-3">
                <div className="w-8 h-8 flex items-center justify-center text-[#0E5C3A] shrink-0">
                  <i className="ri-file-text-line text-xl"></i>
                </div>
                <div>
                  <div className="font-semibold text-gray-800 text-sm">Giấy chứng nhận đăng ký doanh nghiệp</div>
                  <div className="text-gray-600 text-sm mt-1">
                    Số: <strong>0401923171</strong> — Cấp ngày 10/09/2018, đăng ký thay đổi lần 1 ngày 27/05/2022
                  </div>
                  <div className="text-gray-500 text-sm">Do Sở Kế hoạch và Đầu tư TP. Đà Nẵng cấp</div>
                </div>
              </div>
            </div>

            {/* Highlights grid */}
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
              {highlights.map((h) => (
                <div key={h.title} className="flex items-start gap-3">
                  <div className="w-9 h-9 flex items-center justify-center bg-[#0E5C3A]/10 rounded-lg text-[#0E5C3A] shrink-0">
                    <i className={`${h.icon} text-base`}></i>
                  </div>
                  <div>
                    <div className="font-semibold text-gray-800 text-sm">{h.title}</div>
                    <div className="text-gray-500 text-xs mt-0.5 leading-relaxed">{h.desc}</div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
